import { c as _c } from "react/compiler-runtime";
import { memo, useEffect, useRef } from 'react';
import type { ComponentType, HTMLAttributes } from 'react';
import Box from '@classify/react-core-components/Box';
import type { ClientApi } from '@openclassrooms/sdk-web';
import { parsers } from '../../services/parsers';
import baseStyles from '../../styles/base';
type RichContentContainer = keyof HTMLElementTagNameMap | ComponentType<any>;
export interface RichContentProps extends HTMLAttributes<HTMLElement> {
  content: string;
  className?: string;
  component?: RichContentContainer;
  styles?: {
    root: any;
  };
  shouldZoomIntoImage?: boolean;
  shouldLockMediaContent?: boolean;
  accessibleVideoTitle?: string;
  expandableContentLabel?: string;
  projectId?: number;
  userId?: number | null;
  currentUserEmail?: string | null;
  ocClient?: ClientApi;
}
export const RichContent = memo(t0 => {
  const $ = _c(32);
  let content;
  let ocClient;
  let otherProps;
  let projectId;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    ({
      content,
      className: t1,
      component: t2,
      styles: t3,
      shouldZoomIntoImage: t4,
      shouldLockMediaContent: t5,
      accessibleVideoTitle: t6,
      expandableContentLabel: t7,
      ocClient,
      projectId,
      userId: t8,
      currentUserEmail: t9,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = ocClient;
    $[3] = otherProps;
    $[4] = projectId;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
  } else {
    content = $[1];
    ocClient = $[2];
    otherProps = $[3];
    projectId = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
    t9 = $[13];
  }
  const className = t1 === undefined ? "" : t1;
  const component = t2 === undefined ? Box : t2;
  const styles = t3 === undefined ? baseStyles : t3;
  const shouldZoomIntoImage = t4 === undefined ? false : t4;
  const shouldLockMediaContent = t5 === undefined ? false : t5;
  const accessibleVideoTitle = t6 === undefined ? "video" : t6;
  const expandableContentLabel = t7 === undefined ? undefined : t7;
  const userId = t8 === undefined ? null : t8;
  const currentUserEmail = t9 === undefined ? null : t9;
  const richContainerRef = useRef(null);
  const RichContainer = component as any;
  let t10;
  if ($[14] !== ocClient || $[15] !== projectId || $[16] !== shouldLockMediaContent) {
    t10 = () => {
      if (!richContainerRef.current) {
        return;
      }
      parsers.parse(richContainerRef.current, ocClient, projectId, null, {
        shouldLockMediaContent
      });
    };
    $[14] = ocClient;
    $[15] = projectId;
    $[16] = shouldLockMediaContent;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  useEffect(t10);
  const t11 = `oc-richContent ${className}`;
  let t12;
  if ($[18] !== content) {
    t12 = {
      __html: content
    };
    $[18] = content;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = shouldZoomIntoImage ? "true" : null;
  let t14;
  if ($[20] !== RichContainer || $[21] !== accessibleVideoTitle || $[22] !== currentUserEmail || $[23] !== expandableContentLabel || $[24] !== otherProps || $[25] !== projectId || $[26] !== styles.root || $[27] !== t11 || $[28] !== t12 || $[29] !== t13 || $[30] !== userId) {
    t14 = <RichContainer sx={styles.root} ref={richContainerRef} className={t11} dangerouslySetInnerHTML={t12} data-shouldzoomintoimage={t13} data-videotitle={accessibleVideoTitle} data-expandable-content-label={expandableContentLabel} data-current-user-id={userId} data-project-id={projectId} data-current-user-email={currentUserEmail} {...otherProps} />;
    $[20] = RichContainer;
    $[21] = accessibleVideoTitle;
    $[22] = currentUserEmail;
    $[23] = expandableContentLabel;
    $[24] = otherProps;
    $[25] = projectId;
    $[26] = styles.root;
    $[27] = t11;
    $[28] = t12;
    $[29] = t13;
    $[30] = userId;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  return t14;
});
export default RichContent;